import { pushAanZetDataLayer } from "../../AanZet/custom_components/components/datalayer";
import { pushDNBDataLayer } from "../../DeNieuweBibliotheek/custom_components/components/datalayer";
import { pushRdamDataLayer } from "../../Generic/libraries/rdam/datalayer";
import { pushDataLayer as pushDataLayerGeneric } from "../utils/datalayer";
import { getConfig } from "./featureSwitch";
const defaultPush = (data)=>pushDataLayerGeneric({
        event: 'event',
        ...data
    });
const pushDataLayerConfigs = {
    vbp: defaultPush,
    aanzet: pushAanZetDataLayer,
    bkw: defaultPush,
    dnb: pushDNBDataLayer,
    flevo: defaultPush,
    rdam: pushRdamDataLayer,
    twente: defaultPush
};
export const dataLayerConfig = getConfig(pushDataLayerConfigs);
